import React, {useState} from 'react';

interface TruncateTextProps {
    text: string;
    maxLength: number;
    linkStyles?: React.CSSProperties;
}

export const TruncateText = ({text, maxLength, linkStyles}: TruncateTextProps) => {
    const [isTruncated, setIsTruncated] = useState<boolean>(text.length > maxLength);

    const toggleTruncate = () => {
        setIsTruncated(!isTruncated);
    };

    const truncatedText = isTruncated ? `${text.substring(0, maxLength)}...` : text;

    return (
        <span className='truncated-text' style={{display: 'block', margin: 0, padding: 0}}>
            {truncatedText}

            {
                isTruncated && <span onClick={toggleTruncate}
                                     style={{...linkStyles, marginLeft: '5px', cursor: 'pointer'}}>Show More</span>
            }
        </span>
    );
};
